/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ControlProps,
  isBooleanControl,
  RankedTester,
  rankWith
} from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'
import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap'
import ToolTipOverlayComponent from '../../Components/ToolTipOverlay'
import { UISchemaWithToolTip } from '../../constants'
import './styles.scss'

export const Checkbox: React.FC<ControlProps> = ({
  visible,
  path,
  data,
  label,
  handleChange,
  uischema,
  enabled
}) => {
  const uiSchema = uischema as UISchemaWithToolTip

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timeOut: any

    if (!visible) {
      return
    }
    // eslint-disable-next-line prefer-const
    timeOut = setTimeout(() => {
      if (data === undefined && visible) {
        handleChange(path, false)
      }
    }, 200)

    return () => {
      if (timeOut) {
        clearTimeout(timeOut)
      }
    }
  }, [visible, data])

  return (
    <>
      {(uischema as any).groupLabel ? (
        <span className='custom-input-label'>
          {(uischema as any).groupLabel}
        </span>
      ) : (
        <></>
      )}
      {visible && (
        <div>
          <div className='form-group'>
            <Form.Check type='checkbox' id={label as string}>
              <Form.Check.Input
                type='checkbox'
                checked={data ?? false}
                onChange={(ev: { target: { checked: any } }) => {
                  handleChange(path, ev.target.checked)
                }}
                disabled={!enabled}
                data-testid='custom-checkbox'
              />
              <Form.Check.Label>
                {label}
                {uiSchema.toolTipText && (
                  <ToolTipOverlayComponent
                    toolTipText={uiSchema.toolTipText}
                    placement='top'
                    trigger='click'
                  />
                )}
              </Form.Check.Label>
            </Form.Check>
          </div>
        </div>
      )}
    </>
  )
}

export const checkboxControlTester: RankedTester = rankWith(3, isBooleanControl)

export const CheckboxControl = withJsonFormsControlProps(Checkbox)
